import React from 'react';

interface SrUrgencyBadgeProps {
  isUrgent?: boolean | null;
}

export const SrUrgencyBadge: React.FC<SrUrgencyBadgeProps> = ({ isUrgent }) => {
  if (isUrgent !== true) return null;

  return (
    <span
      className="badge badge-danger"
      title="Urgent SR referral"
      aria-label="Urgent SR referral"
    style={{ marginInlineStart: 6 }}
    >
      URGENT
    </span>
  );
};
